import React from 'react';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { IMAGES, MAIN_MOCKUP } from '../data/breakFreeContent';
export function FinalOfferSection() {
  return <section className="w-full border-t border-champagne/25 bg-black" aria-labelledby="final-title" data-id="element-53" data-mp="2j0b8247ou7vb">
      <img src={IMAGES.power} alt="An elegant mother walking through the city with her children — a new chapter" className="h-44 w-full object-cover object-top sm:h-64" width={1500} height={1000} data-id="element-54" data-mp="2nyw8o4quqtka" />

      <div className="mx-auto grid max-w-4xl items-center gap-8 px-5 py-12 sm:grid-cols-2 sm:gap-10 sm:py-16" data-id="element-55" data-mp="1v8xdrspz827p">
        <img src={MAIN_MOCKUP} alt="The complete BREAK FREE™ system — six volumes and six exclusive bonuses" className="mx-auto w-full max-w-[15rem]" width={1080} height={1350} data-id="element-56" data-mp="25135d1cbghmd" />

        <div className="text-center sm:text-left" data-id="element-57" data-mp="1cjqr5um2aqgm">
          <h2 id="final-title" className="font-display text-[1.7rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-58" data-mp="1cifo5x0fxmqk">
            Break Free™
          </h2>
          <p className="mt-2 text-[14px] uppercase tracking-[0.14em] text-body" data-id="element-59" data-mp="22rs20hpecx08">
            6 Volumes + 6 Exclusive Bonuses
          </p>

          <dl className="mt-5 space-y-1 border-t border-charcoal-600 pt-5 text-[12px] uppercase tracking-[0.12em]" data-id="element-60" data-mp="1xs72a52ekkmg">
            <div className="flex items-baseline justify-between text-muted" data-id="element-61" data-mp="1tsojbeu56jm9">
              <dt data-id="element-62" data-mp="1orhardk6dgej">Total value</dt>
              <dd data-id="element-63" data-mp="1oudb18jhwh65">$674</dd>
            </div>
            <div className="flex items-baseline justify-between text-muted" data-id="element-64" data-mp="1jse45oojr24g">
              <dt data-id="element-65" data-mp="1eu4bplu7ifmj">Regular price</dt>
              <dd className="line-through" data-id="element-66" data-mp="1ev5vqft7acge">$197</dd>
            </div>
          </dl>

          <p className="mt-5 text-[10px] font-semibold uppercase tracking-[0.24em] text-champagne" data-id="element-67" data-mp="3e7gqjdiau435">
            Today
          </p>
          <p className="font-display text-6xl font-semibold leading-none text-ivory-50 sm:text-7xl" data-id="element-68" data-mp="398n9jb3szuy8">
            $27
          </p>

          <div className="mt-6 flex justify-center sm:justify-start" data-id="element-69" data-mp="17h4z4f706wom">
            <CtaButton target="checkout" size="md" label="Yes, I'm ready to break free →" data-id="element-70" data-mp="1cb9b5cv4luwk" />
          </div>
          <TrustStrip variant="full" className="mt-3 sm:justify-start" data-id="element-71" data-mp="12j3ie0x1v9gb" />
        </div>
      </div>
    </section>;
}